var _g, _rect, _rect2, _rect3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMyProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Moje_postepy_-_ikona",
    "data-name": "Moje postepy - ikona",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.5,
    height: 30,
    viewBox: "0 0 22.5 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4937",
    "data-name": "Group 4937"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3664",
    "data-name": "Path 3664",
    d: "M405,24V54h22.5V24Zm20,27.5H407.5v-25H425Z",
    transform: "translate(-405 -24)",
    fill: "#464af0"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1769",
    "data-name": "Rectangle 1769",
    width: 2.5,
    height: 7.5,
    transform: "translate(5 15)",
    fill: "#464af0"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1770",
    "data-name": "Rectangle 1770",
    width: 2.5,
    height: 10,
    transform: "translate(10 12.5)",
    fill: "#464af0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1771",
    "data-name": "Rectangle 1771",
    width: 2.5,
    height: 15,
    transform: "translate(15 7.5)",
    fill: "#464af0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMyProgress);
export default __webpack_public_path__ + "static/media/my_progress.613964d55c962ae89f307e5d542f4cea.svg";
export { ForwardRef as ReactComponent };